import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import KeyboardFocusable from '/component/base/ExtKeyboard/KeyboardFocusable';
import Text from '/component/base/Text';
import {MetricsSection} from '/constant/TestIDs';
import {CREATE_NEW_CANDIDATE} from '/enum/popover.enum';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './CreateCandidateButton.style';
import {CreateCandidateButtonProps} from './CreateCandidateButton.types';

export const CreateCandidateButton = ({
  onNavigate = noop,
}: CreateCandidateButtonProps) => {
  const {tt} = useTranslation('screen.CreateCandidateButton');

  const rawLabel = tt('addCandidate', 'Add Candidate');
  const buttonLabel =
    typeof rawLabel === 'string' ? rawLabel : rawLabel?.text ?? 'Add Candidate';

  const touchTP = testProperties(null, true) ?? {};
  const textTP = testProperties(MetricsSection.addCandidateButton) ?? {};

  return (
    <KeyboardFocusable
      {...touchTP}
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel={buttonLabel}
      onPress={() =>
        onNavigate('card', {
          modalName: CREATE_NEW_CANDIDATE,
          modalProps: {},
        })
      }>
      <View style={styles.buttonContainer}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="button"
          style={styles.button}
          {...textTP}
          accessible={false}>
          {`${buttonLabel} +`}
        </Text>
      </View>
    </KeyboardFocusable>
  );
};
